import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function ReparerPlutot() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Réparer plutôt que remplacer
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Avant de remplacer un moteur Nice, nous vérifions systématiquement la cause exacte de la panne. Les moteurs Nice sont particulièrement robustes, et leur défaillance vient souvent d'un récepteur radio OXIBD qui n'intercepte plus le signal, ou d'un émetteur mural dont le contact s'est oxydé. Dans ces cas, changer le moteur serait une erreur coûteuse : la réparation consiste à réinitialiser le récepteur, reprogrammer les émetteurs ou remplacer le condensateur de démarrage. Nous réalisons ces opérations en moins de quarante minutes.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-8">
              Notre méthode de diagnostic est structurée : test de la tension électrique aux bornes du moteur, vérification de la réception du signal radio avec un analyseur de protocole, inspection des fins de course et mesure du couple de démarrage. Si le moteur est effectivement hors d'usage, nous vous proposons un moteur de remplacement adapté à votre volet. Si une réparation suffit, nous la réalisons immédiatement. Pas de remplacement inutile, pas de surcoût.
            </p>
            <div className="bg-[#143A66] rounded-xl p-6 md:p-8 text-white">
              <h3 className="text-lg font-bold mb-2">Diagnostic gratuit</h3>
              <p className="text-white/80 text-sm leading-relaxed mb-5">
                Nous inspectons votre moteur Nice sur place et vous proposons la solution la plus adaptée. Pas de remplacement inutile.
              </p>
              <a
                href="tel:0374473240"
                className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-3 rounded-lg font-semibold text-sm hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
              >
                <i className="ri-phone-line text-base"></i>
                Appeler le 03 74 47 32 40
              </a>
            </div>
          </div>
          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/176113b2ec2a43d410882667b1a2a77b.jpeg"
              alt="Diagnostic précis d'un moteur Nice avant remplacement à Strasbourg"
              className="w-full h-[340px] md:h-[420px]"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}